import { getHomePaths, useWorkspaceId } from "@sg-protect/shell";
import { useMemo } from "react";

const shellPaths = getHomePaths();

const workspacePaths = {
    entry: shellPaths.entry,
    root: shellPaths.root,
    partnerDashboard: `${shellPaths.root}/partner/dashboard`,
    createClientWorkspace: shellPaths.createClientWorkspace,
    billingSubscriptions: `${shellPaths.root}/billing/subscriptions`,
    billingCheckout: `${shellPaths.root}/billing/:intent/:step`,
    billingComplete: `${shellPaths.root}/billing/:intent/complete`,
    homeZeroState: shellPaths.zeroState,
    homeRestrictedState: shellPaths.restrictedState
} as const;

interface GetPathsOptions {
    workspaceId?: string;
}

interface UsePathsOptions {
    prefillWorkspaceId?: boolean;
}

export function getPaths(options?: GetPathsOptions) {
    return options?.workspaceId ? prefillPaths(workspacePaths, options.workspaceId) : workspacePaths;
}

function prefillPaths<const T extends Record<string, string>>(paths: T, workspaceId: string): T {
    return Object.fromEntries(
        Object.entries(paths).map(([key, value]) => [key, value.replaceAll(":workspaceId", workspaceId)])
    ) as T;
}

export function usePaths(options?: UsePathsOptions) {
    const workspaceId = useWorkspaceId();

    return useMemo(() => {
        return options?.prefillWorkspaceId === false ? workspacePaths : prefillPaths(workspacePaths, workspaceId);
    }, [options?.prefillWorkspaceId, workspaceId]);
}
